import { createContext, useContext, useState, useCallback } from 'react'

const AuthContext = createContext(null)

export const useAuth = () => {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within AuthProvider')
  return ctx
}

export const AuthProvider = ({ children }) => {
  const [token, setToken]       = useState(() => localStorage.getItem('dp_token'))
  const [username, setUsername] = useState(() => localStorage.getItem('dp_saved_username') || '')

  const login = useCallback((newToken, user) => {
    setToken(newToken)
    localStorage.setItem('dp_token', newToken)
    if (user) {
      setUsername(user)
      localStorage.setItem('dp_saved_username', user)
    }
  }, [])

  const logout = useCallback(() => {
    setToken(null)
    setUsername('')
    localStorage.removeItem('dp_token')
  }, [])

  return (
    <AuthContext.Provider value={{ token, username, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}
